import * as React from 'react';
import { Space, Button, Typography } from '@sravni/react-design-system';
import { useStyles } from '@sravni/react-utils';
import modules_e5ab2127 from '../styles/RegionDialog.module.less.js';

const { Text } = Typography;
const mergeLocations = (regions) => {
    const regionHash = {};
    regions.forEach(region => {
        const symbol = region.name[0].toUpperCase();
        if (regionHash[symbol]) {
            regionHash[symbol].push(region);
        }
        else {
            regionHash[symbol] = [region];
        }
    });
    return regionHash;
};
/**
 * @description RegionDialog component.
 *
 * @component
 * @example
 * ```jsx
 * <RegionDialog />
 * ```
 */
const RegionsList = React.forwardRef((props, ref) => {
    const { regions = [], onSelect } = props;
    const cx = useStyles(modules_e5ab2127);
    const regionButtonClassnames = cx('regionButton');
    const regionsMap = React.useMemo(() => mergeLocations(regions), [regions]);
    const handleSelect = (option) => (event) => {
        event.preventDefault();
        onSelect(option);
    };
    return (React.createElement("div", { ref: ref, className: cx('list__wrapper') },
        React.createElement("div", { className: cx('list') }, Object.keys(regionsMap).map(symbol => (React.createElement("div", { key: symbol, className: cx('list__item') },
            React.createElement(Text, { size: 16, strong: true, className: "h-mb-8" }, symbol),
            React.createElement(Space, { size: 8, direction: "vertical" }, regionsMap[symbol].map(l => (React.createElement(Button, { key: l.id, "aria-label": l.alias, variant: "text", className: regionButtonClassnames, onClick: handleSelect(l) }, l.name))))))))));
});
RegionsList.defaultProps = {
    title: 'Выберите город',
};

export { RegionsList as default };
//# sourceMappingURL=RegionsList.js.map
